// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Wrapper */
.sidebar {
  background-color: #02042d;
  height: 100vh;
  overflow-y: auto;
  color: white;
  scrollbar-width: thin;
  scrollbar-color: #ededed transparent;
}

.sidebar::-webkit-scrollbar {
  width: 8px;
}
.sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar::-webkit-scrollbar-thumb {
  background-color: #353657;
  border-radius: 4px;
}

/* Logo Section */
.logo {
  padding: 1.5rem 0.5rem 1rem 1.2rem;
  display: flex;
  align-items: left;
  justify-content: left;
}
.logo img {
  max-height: 1.8rem;
  height: auto;
  width: auto;
}

/* Base Sidebar Links */
.sideLinks.MuiListItem-root {
  color: #ffffff !important;
  padding: 0.4rem 1rem !important;
  margin: 4px 0px;
  border-left: 6px solid transparent;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease, border-left 0.2s ease;
  cursor: pointer;
}

/* Hover for Non-active Links */
.sideLinks.MuiListItem-root:hover {
  background-color: #2a2d5b !important;
  color: #ffffff !important;
}

/* Active Sidebar Item */
.sideLinksActive.MuiListItem-root {
  background-color: #292b4d !important;
  color: #ffffff !important;
  border-left: 4px solid #00D1FF !important;
  border-radius: 6px;
  padding-left: calc(1.2rem - 4px) !important;
  cursor: pointer;
}

/* Hover on Active Link - consistent */
.sideLinksActive.MuiListItem-root:hover {
  background-color: #292b4d !important;
  color: #ffffff !important;
}

/* Text inside links */
.sideLinkText {
  margin-left: 0.8rem;
  font-weight: 500;
  font-size: 0.92rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: inherit;
}

/* Nested Dropdown Items */
.MuiCollapse-root .MuiListItem-root {
  padding-left: 2.3rem !important;
  transition: background-color 0.2s ease;
}

.MuiCollapse-root .MuiListItem-root:hover {
  background-color: #2b2e55 !important;
  color: #ffffff !important;
}

/* Rounded scrollbars for left sidebar */
.color-prim-cetacean-blue-500 {
  scrollbar-width: thin;
  scrollbar-color: #353657 transparent;
}
.color-prim-cetacean-blue-500::-webkit-scrollbar {
  width: 8px;
}
.color-prim-cetacean-blue-500::-webkit-scrollbar-track {
  background: transparent;
}
.color-prim-cetacean-blue-500::-webkit-scrollbar-thumb {
  background-color: #353657;
  border-radius: 10px;
  border: 2px solid transparent;
}

/* Scrollbar for main content */
.main-content {
  overflow: auto;
  height: 100vh;
  scrollbar-width: thin;
  scrollbar-color: #353657 transparent;
}
.main-content::-webkit-scrollbar {
  width: 8px;
}
.main-content::-webkit-scrollbar-track {
  background: transparent;
}
.main-content::-webkit-scrollbar-thumb {
  background-color: #353657;
  border-radius: 10px;
  border: 2px solid transparent;
}
`, "",{"version":3,"sources":["webpack://./src/styles/sidebarLayout.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":["/* Sidebar Wrapper */\n.sidebar {\n  background-color: #02042d;\n  height: 100vh;\n  overflow-y: auto;\n  color: white;\n  scrollbar-width: thin;\n  scrollbar-color: #ededed transparent;\n}\n\n.sidebar::-webkit-scrollbar {\n  width: 8px;\n}\n.sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n.sidebar::-webkit-scrollbar-thumb {\n  background-color: #353657;\n  border-radius: 4px;\n}\n\n/* Logo Section */\n.logo {\n  padding: 1.5rem 0.5rem 1rem 1.2rem;\n  display: flex;\n  align-items: left;\n  justify-content: left;\n}\n.logo img {\n  max-height: 1.8rem;\n  height: auto;\n  width: auto;\n}\n\n/* Base Sidebar Links */\n.sideLinks.MuiListItem-root {\n  color: #ffffff !important;\n  padding: 0.4rem 1rem !important;\n  margin: 4px 0px;\n  border-left: 6px solid transparent;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.2s ease, border-left 0.2s ease;\n  cursor: pointer;\n}\n\n/* Hover for Non-active Links */\n.sideLinks.MuiListItem-root:hover {\n  background-color: #2a2d5b !important;\n  color: #ffffff !important;\n}\n\n/* Active Sidebar Item */\n.sideLinksActive.MuiListItem-root {\n  background-color: #292b4d !important;\n  color: #ffffff !important;\n  border-left: 4px solid #00D1FF !important;\n  border-radius: 6px;\n  padding-left: calc(1.2rem - 4px) !important;\n  cursor: pointer;\n}\n\n/* Hover on Active Link - consistent */\n.sideLinksActive.MuiListItem-root:hover {\n  background-color: #292b4d !important;\n  color: #ffffff !important;\n}\n\n/* Text inside links */\n.sideLinkText {\n  margin-left: 0.8rem;\n  font-weight: 500;\n  font-size: 0.92rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: inherit;\n}\n\n/* Nested Dropdown Items */\n.MuiCollapse-root .MuiListItem-root {\n  padding-left: 2.3rem !important;\n  transition: background-color 0.2s ease;\n}\n\n.MuiCollapse-root .MuiListItem-root:hover {\n  background-color: #2b2e55 !important;\n  color: #ffffff !important;\n}\n\n/* Rounded scrollbars for left sidebar */\n.color-prim-cetacean-blue-500 {\n  scrollbar-width: thin;\n  scrollbar-color: #353657 transparent;\n}\n.color-prim-cetacean-blue-500::-webkit-scrollbar {\n  width: 8px;\n}\n.color-prim-cetacean-blue-500::-webkit-scrollbar-track {\n  background: transparent;\n}\n.color-prim-cetacean-blue-500::-webkit-scrollbar-thumb {\n  background-color: #353657;\n  border-radius: 10px;\n  border: 2px solid transparent;\n}\n\n/* Scrollbar for main content */\n.main-content {\n  overflow: auto;\n  height: 100vh;\n  scrollbar-width: thin;\n  scrollbar-color: #353657 transparent;\n}\n.main-content::-webkit-scrollbar {\n  width: 8px;\n}\n.main-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n.main-content::-webkit-scrollbar-thumb {\n  background-color: #353657;\n  border-radius: 10px;\n  border: 2px solid transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
